import { listControl, FULL_NAME, PAGE_NAME, CAMPAIGN_NAME, NAME, LIVE_CAMPAIGN_NAME, PRODUCT_INFO, PRODUCT_KEYWORD, SURNAME } from './constant';

const LIST_REG_EXP = [
   ...listControl,
   FULL_NAME,
   PAGE_NAME,
   CAMPAIGN_NAME,
   NAME,
   SURNAME,
   LIVE_CAMPAIGN_NAME,
   PRODUCT_INFO,
   PRODUCT_KEYWORD
];

export const getParts = (str) => {
   const regex = new RegExp(LIST_REG_EXP.map(r => r.code).join('|'), 'g');
   let parts = str.split(regex);
   let index = 0;
   const result = [];
   str.replace(regex, match => {
      result.push(parts[index++]);
      result.push(match);
   });
   result.push(parts[index]);
   return result;
}

export const replaceParagraph = (paragraph) => {
   const parts = getParts(paragraph);
   parts.forEach((part) => {
      const fi = LIST_REG_EXP.find((item) => item.code == part);
      if (fi) {
         paragraph = paragraph.replace(fi.code, fi.name);
      }
   });

   return paragraph;
}